import type { ProductType } from "@/lib/generated/product-types";

const MASS_NOUN_PLURALS = new Set(["Lumber", "Equipment"]);

export function isMassNoun(productType: ProductType): boolean {
  return MASS_NOUN_PLURALS.has(productType.pluralDisplayName);
}

export function productTypeInSentence(productType: ProductType): string {
  return productType.pluralDisplayName
    .split(" ")
    .map((word) => (word === word.toUpperCase() ? word : word.toLowerCase()))
    .join(" ");
}

export function gradingHeadline(productType: ProductType | undefined): string {
  if (!productType) return "What is your used packaging worth?";
  const verb = isMassNoun(productType) ? "is" : "are";
  return `What ${verb} your used ${productTypeInSentence(productType)} worth?`;
}

export const GRADING_INTRO =
  "Upload photos. No account needed.";
